<script>
    import BookTitle from "../components/BookTitle.svelte";
    import Title from "../components/Title.svelte";
    import Background from "../components/Background.svelte";
    import {links} from "../links";
</script>

<section id="book-info">
    <Background>
        <img class="bg" src="images/index/book-bg.svg">
    </Background>

    <div class="background">
    </div>
    <Title title="『红宝书』全套新版" hint="书籍配套 视听促记 高效智能 随时复习"/>
    <div class="content">
        <a class="book" href={links.写作} target="_blank" rel="noopener noreferrer">
            <BookTitle title="「考研写作180篇」" hint="写作规律 高度概括" moreHint="重要考点 全面预测"/>
            <img class="book-cover" src="images/index/写作封面.png"/>
        </a>

        <a class="book" href={links.词汇} target="_blank" rel="noopener noreferrer">
            <BookTitle title="「考研英语词汇」" hint="收词全面 解析深入" moreHint="高效记忆 首选精品"/>
            <img class="book-cover" src="images/index/词汇封面.png"/>
        </a>

        <a class="book" href={links.真题} target="_blank" rel="noopener noreferrer">
            <BookTitle title="「考研10年真题」" hint="归类分解 套题精练" moreHint="解析精准 考点突出"/>
            <img class="book-cover" src="images/index/真题封面.png"/>
        </a>
    </div>
</section>

<style>
    #book-info {
        margin-top: 84px;
    }

    .bg {
        position: absolute;
        top: 124px;
        width: 375px;
    }

    .content {
        margin-top: 28px;
        display: grid;
        align-items: center;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, minmax(116px, 1fr));
    }

    .book {
        display: block;
        text-align: center;
    }

    .book-cover {
        margin-top: 18px;
        width: 116px;
    }
</style>
